import { render, staticRenderFns } from "./phone2.vue?vue&type=template&id=cc94e2a8&scoped=true&"
var script = {}
import style0 from "./phone2.vue?vue&type=style&index=0&id=cc94e2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc94e2a8",
  null
  
)

export default component.exports